// extracted by mini-css-extract-plugin
export default {"buttonBlock":"buttonBlock__ODBmM","saveAndCancel":"saveAndCancel__NzQzZ","deleteButton":"deleteButton__NWQ1N"};